// extracted by mini-css-extract-plugin
export default {"card":"card-ercJe","headline":"headline-q8A20"};